import { combineReducers } from 'redux'

import { FETCH_DMARC_INFO_REQUEST, SUBMIT_DMARC_INFO_REQUEST } from './constants'

const initialState = {
  userRequestedDmarcInfo: false,
  isLoading: false,
  error: null,
}

const dmarcReducer =
  () =>
  (state = initialState, action = {}) => {
    if (!action?.type) {
      return state
    }

    switch (action.type) {
      case FETCH_DMARC_INFO_REQUEST.INITIATE:
      case SUBMIT_DMARC_INFO_REQUEST.INITIATE:
        return {
          ...state,
          isLoading: true,
          error: null,
        }

      case SUBMIT_DMARC_INFO_REQUEST.SUCCESS:
      case FETCH_DMARC_INFO_REQUEST.SUCCESS:
        return {
          ...state,
          userRequestedDmarcInfo: action.payload?.userRequestedDmarcInfo ?? false,
          isLoading: false,
          error: null,
        }

      case FETCH_DMARC_INFO_REQUEST.ERROR:
        return {
          ...state,
          isLoading: false,
          error: action.error,
        }

      default:
        return state
    }
  }

export default function () {
  // eslint-disable-next-line no-shadow
  const initialState = combineReducers({
    self: dmarcReducer(),
  })

  return (state = initialState) => state
}
